// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tcWh","title":"styles_title__1jqeH"};